import React from "react";
import { Doughnut } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

const formatCurrency = (value) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  }).format(value || 0);

const withAlpha = (hex, alpha) => {
  const match = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex || "");
  if (!match) return hex;
  const [, r, g, b] = match;
  return `rgba(${parseInt(r, 16)}, ${parseInt(g, 16)}, ${parseInt(b, 16)}, ${alpha})`;
};

const ClientSplitChart = ({ segments = [] }) => {
  const chartData = {
    labels: segments.map((segment) => `${segment.label} AUM`),
    datasets: [
      {
        data: segments.map((segment) => segment.aum),
        backgroundColor: segments.map((segment) => withAlpha(segment.accent, 0.75)),
        borderColor: segments.map((segment) => segment.accent),
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "bottom",
        labels: { color: "#fff", usePointStyle: true, padding: 18 },
      },
      tooltip: {
        backgroundColor: "rgba(0, 0, 0, 0.86)",
        titleColor: "#fff",
        bodyColor: "#fff",
        borderColor: "#2AF598",
        borderWidth: 1,
        callbacks: {
          label: (context) => `${context.label}: ${formatCurrency(context.parsed)}`,
        },
      },
    },
    cutout: "62%",
  };

  return <Doughnut data={chartData} options={options} />;
};

export default ClientSplitChart;
